import React from 'react';

import NoData from '../../assets/images/no-data.gif';
import MyButton from '../../shared-components/button/Button';

/**
 * Handles the submission of a form or an action.
 *
 * This function is triggered when the user submits the form, 
 * and it processes the input values as necessary.
 
 */

/**
 * Forbidden component renders a message indicating restricted access.
 *
 * This component is typically displayed when a user tries to access
 * a page or resource they don't have permission to view.
 * @returns {JSX.Element} The rendered component showing a "Forbidden" message.
 */
function Forbidden() {
  return (
    <div className="forbidden-error-main-page">
      <div className="image-container">
        <img src={NoData} alt="no-data" />
      </div>
      <div className="content-container">
        <h3>No Data Found</h3>
        <p>The page was not found</p>
        <div className="content-btn">
          <MyButton label="Take me to home" buttonType="submit" />
        </div>
      </div>
    </div>
  );
}

export default Forbidden;
